export default class DuplicateLoginError extends Error {}
